import IconCommunity, {
	IconCommunityProps as _IconCommunityProps,
} from './IconCommunity';

export { IconCommunity };
export type IconCommunityProps = _IconCommunityProps;
